import { Link } from "react-router-dom";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { LoginForm } from "../../components/LoginForm";
import { LoginTop } from "../../components/LoginTop";
import { useBrand } from "../../context/BrandContext";
import { useVisualViewportHeight } from "../../hooks/useWizardViewportHeight";
import defaultAppLogo from "../../assets/smarttt-wordmark.png";
import { resolveClubImageUrl } from "../../utils/resolveClubImageUrl";
import "../../components/Login.css";

export const Login = () => {
  const { t, i18n } = useTranslation();
  const { brand } = useBrand();
  const [selectedlng, setselectedlng] = useState(
    localStorage.getItem("i18nextLng") || "en"
  );

  // Pin the page to the visual viewport and keep the focused field above
  // the keyboard, including the feature bar on phones such as the S24.
  useVisualViewportHeight({
    heightVar: "--login-vvh",
    topVar: "--login-vv-top",
    safeBottomVar: "--login-safe-bottom",
    keyboardClass: "login-keyboard-open",
    scrollFocusedFields: false,
    pinFocusedField: true,
    keyboardBarVar: "--login-kb-bar",
  });

  const changeLanguage = (e) => {
    const lng = e.target.value;
    setselectedlng(lng);
    localStorage.setItem("lng", lng);
    localStorage.setItem("i18nextLng", lng);
    i18n.changeLanguage(lng);
  };

  const logoSrc = resolveClubImageUrl(brand.logo_url) || defaultAppLogo;
  const brandName = brand.brand_name || "SmartTT Club";

  return (
    <div className="landing-container login-page">
      <header className="landing-header">
        <div className="header-content">
          <Link to="/" className="logo-container login-page-logo">
            <img src={logoSrc} alt={brandName} className="header-logo" />
          </Link>
          <div className="language-selector">
            <select
              value={selectedlng}
              onChange={changeLanguage}
              className="lang-select"
              aria-label={t("changelanguage")}
            >
              <option value="en">🇺🇸 {t("language_english")}</option>
              <option value="fr">🇫🇷 {t("language_french")}</option>
              <option value="de">🇩🇪 {t("language_german")}</option>
              <option value="es">🇪🇸 {t("language_spanish")}</option>
              <option value="nl">🇳🇱 {t("language_dutch")}</option>
              <option value="pt">🇵🇹 {t("language_portuguese")}</option>
            </select>
          </div>
        </div>
      </header>

      <main className="login-page-shell">
        <section className="login-auth-card" aria-labelledby="login-heading">
          <LoginTop />
          <LoginForm />
        </section>

        <aside className="signup-panel" aria-labelledby="signup-heading">
          <p className="signup-panel__kicker">{t("new_here")}</p>
          <h2 id="signup-heading" className="signup-panel__title">
            {t("signup_cta")}
          </h2>
          <p className="signup-panel__text">{t("signup_panel_text")}</p>
          <Link to="/register" className="signup-button">
            {t("signup")}
          </Link>
        </aside>
      </main>
    </div>
  );
};
